import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { User } from '~types/api/user';
import { useUserStore } from '~providers/userStore/zustand';

export function useGetUserAccount(user_id: string, shouldFetch = true) {
  const token = useUserStore(state => state.token);

  console.log('🔍 useGetUserAccount called with:', { user_id, token: token ? 'EXISTS' : 'MISSING', shouldFetch });

  return useQuery<User | undefined, Error>(
    ['userAccount', user_id],
    async () => {
      console.log('🔍 useGetUserAccount query function executing with:', { user_id, token: token ? 'EXISTS' : 'MISSING' });

      if (!user_id || !token) {
        console.log('🔍 useGetUserAccount: Missing user_id or token, returning undefined');
        return undefined;
      }

      const userResponse = await fetch(`${BASE_API_URL}users/${user_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      });
      
      if (!userResponse.ok) {
        if (userResponse.status === 404) {
          console.log('🔍 useGetUserAccount: User not found (404)');
          return undefined;
        }
        throw new Error(`Failed to get user account: ${userResponse.status}`);
      }
      const userData = (await userResponse.json()) as User;
      console.log(userData, 'userResponseuserResponse');
      return userData;
    },
    {
      enabled: shouldFetch && !!user_id && !!token,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
}
